module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"ru":{"title":"Сортировка","popular":"По популярности","rating":"По рейтингу","rating_brand":"По рейтингу","new":"По дате","new_brand":"По дате","desc":"По убыванию","asc":"По возрастанию"}}')
  delete Component.options._Ctor
}
